import { MotionProps, motion } from "framer-motion";
import { PropsWithChildren, useCallback, useEffect } from "react";
import { cn } from "../../utils/classes";

const defaultViewportOptions = {
  amount: "all",
} as const;
type PageNavSectionProps = {
  id: string;
  className?: string;
  anchorClassName?: string;
  onViewLeave: (sectionName: string) => void;
  onViewEnter: (sectionName: string) => void;

  onSectionRegister: (sectionName: string) => void;
  onSectionUnregister: (sectionName: string) => void;

  viewportOptions?: MotionProps["viewport"];
};

export const GenericPageNavSection = ({
  id,
  children,
  className,
  anchorClassName,
  onViewEnter,
  onViewLeave,
  onSectionRegister,
  onSectionUnregister,
  viewportOptions = defaultViewportOptions,
}: PropsWithChildren<PageNavSectionProps>) => {
  const handleViewEnter = useCallback(() => {
    onViewEnter?.(id);
  }, [onViewEnter, id]);

  const handleViewLeave = useCallback(() => {
    onViewLeave?.(id);
  }, [onViewLeave, id]);

  useEffect(() => {
    onSectionRegister?.(id);
    return () => {
      onSectionUnregister?.(id);
    };
  }, []);

  return (
    <motion.section
      data-cy={id}
      className={cn("relative", className)}
      onViewportEnter={handleViewEnter}
      onViewportLeave={handleViewLeave}
      viewport={viewportOptions}
    >
      {/*this is as sometimes we have to set offset*/}
      <span id={id} className={cn("absolute size-0", anchorClassName)}></span>
      {children}
    </motion.section>
  );
};
